var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 25.2C6 20.6896 9.91751 17.0333 14.75 17.0333C19.5825 17.0333 23.5 20.6896 23.5 25.2M19.75 8.86662C19.75 11.4439 17.5114 13.5333 14.75 13.5333C11.9886 13.5333 9.75 11.4439 9.75 8.86662C9.75 6.28929 11.9886 4.19995 14.75 4.19995C17.5114 4.19995 19.75 6.28929 19.75 8.86662Z",
    stroke: "#1E1E1E",
    strokeOpacity: 0.8,
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.a7f977b92d873bd33661411e89049992.svg";
export { ForwardRef as ReactComponent };